import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Settings.css';

const Settings: React.FC = () => {
  const { user } = useAuth();
  const [designation, setDesignation] = useState<string>('');

  useEffect(() => {
    // Always enforce light theme
    document.documentElement.setAttribute('data-theme', 'light');
    document.body.classList.remove('dark-theme');
    document.body.classList.add('light-theme');
    localStorage.setItem('theme', 'light');

    const savedDesignation = localStorage.getItem('designation');
    if (savedDesignation) setDesignation(savedDesignation);
  }, []);

  const handleDesignationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newDesignation = e.target.value;
    setDesignation(newDesignation);
    localStorage.setItem('designation', newDesignation);
  };

  const avatarInitial = (user?.user_metadata?.full_name || user?.email || 'U').charAt(0).toUpperCase();

  return (
    <Layout>
      <div className="settings-container">
        <div className="settings-header">
          <p className="settings-subtitle">Manage your account and preferences</p>
        </div>

        <div className="settings-content">
          {/* Profile Information Section */}
          <div className="settings-section-card">
            <div className="settings-section-header">
              <div className="settings-section-icon settings-icon-profile">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <h2 className="settings-section-title">Profile Information</h2>
            </div>

            {/* Avatar + name row */}
            <div className="settings-profile-row">
              <div className="settings-avatar">{avatarInitial}</div>
              <div className="settings-profile-info">
                <span className="settings-profile-name">{user?.user_metadata?.full_name || 'Not set'}</span>
                <span className="settings-profile-email">{user?.email}</span>
              </div>
            </div>

            <div className="settings-divider" />

            <div className="settings-form-group">
              <label className="settings-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                Email Address
              </label>
              <div className="settings-value">{user?.email}</div>
            </div>

            <div className="settings-form-group">
              <label className="settings-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
                Designation
              </label>
              <select className="settings-select-input" value={designation} onChange={handleDesignationChange}>
                <option value="">Select designation</option>
                <option value="Product Manager">Product Manager</option>
                <option value="Business Analyst">Business Analyst</option>
                <option value="Consultant">Consultant</option>
                <option value="Project Manager">Project Manager</option>
                <option value="Product Owner">Product Owner</option>
                <option value="Scrum Master">Scrum Master</option>
                <option value="Other">Other</option>
              </select>
              <p className="settings-info">Select your professional designation or role.</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Settings;
